module.exports = __webpack_public_path__ + "static/media/rew.0b35e6c9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/rew.svg
// module id = 26
// module chunks = 1